import Muuri from 'muuri'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const REVEAL_DIRS = [
  { y: 70 },
  { x: -70 },
  { y: -70 },
  { x: 70 },
]

export default class BlogList {
  constructor(el) {
    this.el = el
    this.section = el.closest('.blog-list')
    this.filtersEl = this.section.querySelector('.blog-list--filter')
    this.revealDone = false
    this.init()
  }

  init() {
    const grid = new Muuri(this.el, {
      items: '.blog-list--item',
      layoutDuration: 350,
      layoutEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      showDuration: 0,
      hideDuration: 200,
    })

    if (this.filtersEl) {
      this.filtersEl.addEventListener('click', (e) => {
        const li = e.target.closest('li[data-filter]')
        if (!li) return

        const filterValue = li.getAttribute('data-filter') || '*'

        grid.filter((item) => {
          const el = item.getElement()
          if (filterValue === '*') return true
          return el.matches(filterValue)
        })

        this.filtersEl.querySelectorAll('li').forEach(n => n.classList.remove('is-active'))
        li.classList.add('is-active')
      })
    }

    const relayout = () => grid.refreshItems().layout()

    grid.on('layoutEnd', () => {
      if (this.revealDone) return
      this.revealDone = true
      ScrollTrigger.refresh()
      this.initReveal()
    })

    window.addEventListener('load', relayout)
    this.el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return
      img.addEventListener('load', relayout, { once: true })
      img.addEventListener('error', relayout, { once: true })
    })
  }

  initReveal() {
    this.el.querySelectorAll('.blog-list--card').forEach((card, i) => {
      const dir = REVEAL_DIRS[i % REVEAL_DIRS.length]
      gsap.set(card, { ...dir, opacity: 0 })
      gsap.to(card, {
        x: 0,
        y: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      })
    })
  }
}
